import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { creditClient } from '@modules/Credit/client/creditClient';
import { cacheKeys } from '../config';

export const useCreditCrud = () => {
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const editCredit = useMutation({
    mutationKey: [cacheKeys.editCredit],
    mutationFn: creditClient.editCredit,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getCredit, data.data.id],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    editCredit,
  };
};